<template>
    <v-dialog
        :value="isOpen"
        max-width="1300px"
        height="1500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Paczka z odbiorem osobistym
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-container fluid class="pa-0">
                            <v-row dense justify="end">
                                <v-col cols="12" sm="4" lg="3">
                                    <v-text-field
                                        v-model="filters.customerName"
                                        label="Klient"
                                        single-line
                                        clearable
                                        hide-details
                                        solo
                                        @keyup.enter="changeFilter"
                                        @click:append="changeFilter"
                                        @click:clear="clearFilter('customerName')"
                                    />
                                </v-col>
                                <v-col cols="12" sm="4" lg="3">
                                    <v-text-field
                                        v-model="filters.packageNumber"
                                        label="Numer paczki"
                                        single-line
                                        clearable
                                        hide-details
                                        solo
                                        @keyup.enter="changeFilter"
                                        @click:append="changeFilter"
                                        @click:clear="clearFilter('packageNumber')"
                                    />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-data-table
                                v-model="personalPickupsPackagesSelected"
                                :headers="headers"
                                :items="personalPickupsPackages"
                                :loading="actionLoading"
                                :page.sync="pagination.page"
                                :server-items-length="pagination.itemsLength"
                                :footer-props="footerProps"
                                show-select
                                item-key="id"
                                name="personalPickupsPackagesData"
                                @pagination="updatePagination"
                            >
                                <template #item.number="{item}">
                                    <template v-if="item.number">
                                        {{ item.number }}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </template>
                                <template #item.numberOfOrders="{item}">
                                    <template v-if="item.numberOfOrders">
                                        {{ item.numberOfOrders }}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </template>
                                <template #item.numberOfPackages="{item}">
                                    <template v-if="item.numberOfPackages">
                                        {{ item.numberOfPackages }}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    :loading="actionLoading"
                    @click="onSave()"
                >
                    Dodaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import customFilters from '@/mixins/customFilters'

export default {
    name: 'PersonalPackagesPickupOrdersDialog',
    mixins: [
        pagination,
        tooltipDelay,
        filters,
        customFilters,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        action: {
            type: String,
            default: null
        },
        listSelected: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            personalPickupsPackagesSelected: [],
            actionLoading: false,
            personalPickup: null,
            personalPickupsPackages: [],
            headers: [
                {
                    text: 'Numer',
                    value: 'number',
                    sortable: false,
                    width: 200
                },
                {
                    text: 'Klient',
                    value: 'customer',
                    sortable: false,
                },
                {
                    text: 'Liczba zamówień',
                    value: 'numberOfOrders',
                    sortable: false,
                },
                {
                    text: 'Liczba paczek',
                    value: 'numberOfPackages',
                    sortable: false,
                },
                {
                    text: 'Całkowita kwota',
                    value: 'totalAmount',
                    sortable: false,
                },
            ]
        }
    },
    computed: {
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }

            }

            return query
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean && !this.personalPickupsPackages.length) {
                this.getPersonalPickupPackages()
            }
            this.personalPickupsPackagesSelected = this.listSelected
        }
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    methods: {
        getPersonalPickupPackages() {
            this.actionLoading = true
            this.$store.dispatch('shipments/personalPickups/getPackages', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then((response) => {
                    this.handlePaginationResponse(response)
                    const results = response?.data?.results ?? []

                    this.personalPickupsPackages = results.map(item => ({
                        ...item,
                        customer: item.orders?.at(0)?.customer ?? '-'
                    }))
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onSave() {
            this.$emit('on-save', this.personalPickupsPackagesSelected)
            this.onClose()
        },
        onClose() {
            setTimeout(() => {
                this.actionLoading = false
                this.personalPickupsPackagesSelected = []
            }, 500)
            this.$emit('on-close')
        },
        changeFilter() {
            this.resetPagination()
            this.getPersonalPickupPackages()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getPersonalPickupPackages()
            }
            this.clearPaginationPending()
        },
    },
}
</script>
